import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/css/main.css'
import apiClient from './services/api'

// Ensure API client is available globally if needed
window.apiClient = apiClient

// Create and mount Vue app
const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')